/* Lynexas — Frequently Bought Together.
   Tick/bo tick -> tinh lai tong. "Add selected to cart" -> /cart/add.js mot lan
   cho tat ca san pham da chon, roi phat CartLinesUpdateEvent dung hop dong cua
   Horizon (cart-drawer.js / cart-icon.js / component-cart-items.js dang nghe)
   nen gio hang tu mo va cap nhat nhu khi bam Add to cart that. */
import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  if (window.__lyxFbt) return;
  window.__lyxFbt = true;

  const root = () => document.querySelector('[data-lyx-fbt]');

  function checkedRows() {
    const box = root();
    if (!box) return [];
    return Array.from(box.querySelectorAll('[data-lyx-fbt-check]')).filter((c) => c.checked);
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Cap nhat toan bo khoi theo trang thai tick:
     tong (kem gia gach) - ẩn/hien anh o hang tren - lam mo dong bi bo tick */
  function refresh() {
    const box = root();
    if (!box) return;

    const all = Array.from(box.querySelectorAll('[data-lyx-fbt-check]'));
    let total = 0;
    let was = 0;

    all.forEach((c) => {
      const on = c.checked;
      if (on) {
        total += parseInt(c.dataset.price, 10) || 0;
        was += parseInt(c.dataset.compare, 10) || 0;
      }
      // lam mo dong bi bo tick
      c.closest('.lyx-fbt__item')?.classList.toggle('lyx-fbt__item--off', !on);
      // an anh tuong ung o hang tren
      const thumb = box.querySelector(`[data-lyx-fbt-thumb="${CSS.escape(c.dataset.handle || '')}"]`);
      if (thumb) thumb.hidden = !on;
    });

    // dau "+" chi hien tu anh thu hai tro di (tinh tren cac anh dang hien)
    const visible = Array.from(box.querySelectorAll('[data-lyx-fbt-thumb]')).filter((t) => !t.hidden);
    visible.forEach((t, i) => {
      const plus = t.querySelector('.lyx-fbt__plus');
      if (plus) plus.hidden = i === 0;
    });

    const out = box.querySelector('[data-lyx-fbt-total]');
    if (out) out.textContent = formatMoney(total, box.dataset.currency);

    const wasEl = box.querySelector('[data-lyx-fbt-was]');
    if (wasEl) {
      wasEl.hidden = was <= total;
      wasEl.textContent = formatMoney(was, box.dataset.currency);
    }

    const btn = box.querySelector('[data-lyx-fbt-add]');
    if (btn) btn.disabled = total === 0;
  }

  function cartItemsSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }

  // Gop trung: cung variant duoc chon 2 lan thi cong don so luong
  function buildItems(rows) {
    const map = new Map();
    rows.forEach((c) => {
      const id = Number(c.dataset.variantId);
      if (!id) return;
      map.set(id, (map.get(id) || 0) + 1);
    });
    return Array.from(map, ([id, quantity]) => ({ id, quantity }));
  }

  async function addSelected(btn) {
    const rows = checkedRows();
    const items = buildItems(rows);
    if (!items.length) return;

    const sectionIds = cartItemsSectionIds();
    const payload = { items };
    if (sectionIds.length) payload.sections = sectionIds.join(',');

    // Dung DUNG helper cua Shopify (khong tu che Promise / tu dung object cart) —
    // cart-drawer.js va component-cart-items.js doi dung hop dong nay moi chiu
    // mo drawer va morph noi dung, nhat la khi gio dang RONG.
    const deferred = CartLinesUpdateEvent.createPromise();
    const totalQty = items.reduce((s, i) => s + i.quantity, 0);

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
        promise: deferred.promise,
      })
    );

    const original = btn.textContent;
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const added = await res.json();
      if (added.status) throw new Error(added.description || 'add failed');

      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const ajaxCart = await cartRes.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          itemCount: totalQty,
          sections: added.sections,
          source: 'lynexas-fbt',
          didError: false,
        },
      });
    } catch (e) {
      try {
        const ajaxCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: { items: ajaxCart.items, source: 'lynexas-fbt', didError: true },
        });
      } catch (e2) {
        deferred.reject(e);
      }
      btn.textContent = 'Please try again';
      setTimeout(() => {
        btn.textContent = original;
      }, 2500);
    } finally {
      btn.disabled = false;
      refresh();
    }
  }

  document.addEventListener('change', (event) => {
    if (event.target.closest('[data-lyx-fbt-check]')) refresh();
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-lyx-fbt-add]');
    if (!btn) return;
    event.preventDefault();
    addSelected(btn);
  });

  /* Trinh duyet co the KHOI PHUC trang thai tick cu khi F5 hoac khi quay lai trang
     (bfcache) — chay lai sau nhung moc do de tong/anh khong bi lech voi o tick. */
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
})();
